
// import { proxy } from "valtio";

// const state = proxy({
//   updateTrigger: 0,
//   intro: true,
//   color: "#EFBD48",

//   frontText: "",
//   backText: "",
//   frontNumber: "",
//   backNumber: "",

//   svg: null,

//   frontLogo: null,
//   backLogo: null,
//   imagesPattern: {},

//   viewSide: 'front',

//   modelName: '', 
//   patternColors: {},
//   selectedPattern: {},
//   selectedFonts: "Arial",
//   textFonts: {
//     front: "Arial", 
//     back: "Arial"
//   },
//   numberFonts: {
//     front: "Arial", 
//     back: "Arial"
//   },
//   // Separate text colors and number colors
//   textColors: { 
//     front: '#ffffff', 
//     back: '#ffffff' 
//   },
//   numberColors: { 
//     front: '#ffffff', 
//     back: '#ffffff' 
//   },
//   partColors: { front: '', back: '' }, // Keep this for other parts if needed
//   gradientColors: {}, 
//   parts:[],
//   scene:null,
//   blob:null,
//   newKey:null,

// });

// export default state;

// index.js
// import { proxy } from "valtio";

// const state = proxy({
//   updateTrigger: 0,
//   intro: true,
//   color: "#EFBD48",
  
//   products: {
//     product1: {
//       id: 1,
//       frontText: "",
//       backText: "",
//       frontNumber: "",
//       backNumber: "",
//       svg: null,
//       frontLogo: null,
//       backLogo: null,
//       imagesPattern: {},
//       viewSide: 'front',
//       patternColors: {},
//       selectedPattern: {},
//       selectedFonts: "Arial",
//       textFonts: { front: "Arial", back: "Arial" },
//       numberFonts: { front: "Arial", back: "Arial" },
//       textColors: { front: '#ffffff', back: '#ffffff' },
//       numberColors: { front: '#ffffff', back: '#ffffff' },
//       partColors: { front: '', back: '' },
//       gradientColors: {},
//       parts: [],
//       newKey: null,
//       isActive: true
//     }
//   },
//   currentProductId: "product1",
//   scene: null,
//   blob: null,
  
//   get currentProduct() {
//     return this.products[this.currentProductId];
//   },

//   duplicateProduct: function(sourceId, targetId) {
//     const source = this.products[sourceId];
//     if (!source) return;

//     const clonedData = JSON.parse(JSON.stringify(source));

//     this.products[targetId] = {
//       ...clonedData,
//       id: parseInt(targetId.replace('product', '')),
//       isActive: false
//     };

//     this.currentProductId = targetId;
//     this.products[sourceId].isActive = false;
//     this.products[targetId].isActive = true;
    
//     this.updateTrigger++;
//   },

//   switchProduct: function(productId) {
//     if (this.products[productId]) {
//       this.currentProductId = productId;
//       // Update all products' active status
//       Object.keys(this.products).forEach(id => {
//         this.products[id].isActive = (id === productId);
//       });
//       this.updateTrigger++;
//     }
//   },
  
//   // Update current product property
//   updateCurrentProduct: function(key, value) {
//     if (this.products[this.currentProductId]) {
//       this.products[this.currentProductId][key] = value;
//       this.updateTrigger++;
//     }
//   },

//    setViewSide: function(side) {
//     if (this.products[this.currentProductId]) {
//       this.products[this.currentProductId].viewSide = side;
//       this.updateTrigger++;
//     }
//   },

//    forceRefresh: function() {
//     this.updateTrigger = (this.updateTrigger || 0) + 1;
    
//     // Also trigger updates on all products
//     Object.keys(this.products).forEach(productId => {
//       const product = this.products[productId];
//       // Touch a property to trigger reactivity
//       if (product) {
//         product.id = product.id; // This will trigger observers
//       }
//     });
//   },
// });

// export default state;

import { proxy } from "valtio";

const state = proxy({
  updateTrigger: 0,
  intro: true,
  color: "#EFBD48",
  
  products: {
    product1: {
      id: 1,
      frontText: "",
      backText: "",
      frontNumber: "",
      backNumber: "",
      svg: null,
      modelName: null, // Add modelName to track which model this product uses
      frontLogo: null,
      backLogo: null,
      imagesPattern: {},
      viewSide: 'front',
      patternColors: {},
      selectedPattern: {},
      selectedFonts: "Arial",
      textFonts: { front: "Arial", back: "Arial" },
      numberFonts: { front: "Arial", back: "Arial" },
      textColors: { front: '#ffffff', back: '#ffffff' },
      numberColors: { front: '#ffffff', back: '#ffffff' },
      partColors: {},
      gradientColors: {},
      parts: [],
      newKey: null,
      isActive: true,
      // Add material state for the 3D model
      materialState: {
        texturesLoaded: false,
        materialsApplied: false,
        lastModelUrl: null
      }
    }
  },
  currentProductId: "product1",
  scene: null,
  blob: null,
  
  get currentProduct() {
    return this.products[this.currentProductId];
  },

  duplicateProduct: function(sourceId, targetId) {
    const source = this.products[sourceId];
    if (!source) return;

    // Deep clone with proper handling of nested objects
    const clonedData = this.deepCloneProduct(source);
    
    // Create new product with incremented ID
    const newId = parseInt(targetId.replace('product', ''));
    
    this.products[targetId] = {
      ...clonedData,
      id: newId,
      isActive: false,
      // Reset material state to force fresh texture loading
      materialState: {
        texturesLoaded: false,
        materialsApplied: false,
        lastModelUrl: clonedData.modelName
      }
    };

    // Deactivate old product, activate new one
    this.products[sourceId].isActive = false;
    this.products[targetId].isActive = true;
    this.currentProductId = targetId;
    
    // Force a complete refresh
    this.forceRefresh();
    
    console.log(`✅ Duplicated product ${sourceId} to ${targetId} with model: ${clonedData.modelName}`);
  },

  // Helper method for deep cloning products
  deepCloneProduct: function(product) {
    try {
      const cloned = JSON.parse(JSON.stringify(product));
      
      // Ensure special properties are properly cloned
      if (cloned.imagesPattern) {
        Object.keys(cloned.imagesPattern).forEach(key => {
          if (cloned.imagesPattern[key]?.image) {
            cloned.imagesPattern[key] = {
              ...cloned.imagesPattern[key],
              image: String(cloned.imagesPattern[key].image)
            };
          }
        });
      }
      
      return cloned;
    } catch (error) {
      console.error("Error cloning product:", error);
      return {
        id: product.id,
        frontText: "",
        backText: "",
        frontNumber: "",
        backNumber: "",
        svg: null,
        modelName: product?.modelName || null,
        frontLogo: null,
        backLogo: null,
        imagesPattern: {},
        viewSide: "front",
        patternColors: {},
        selectedPattern: {},
        selectedFonts: "Arial",
        textFonts: { front: "Arial", back: "Arial" },
        numberFonts: { front: "Arial", back: "Arial" },
        textColors: { front: '#ffffff', back: '#ffffff' },
        numberColors: { front: '#ffffff', back: '#ffffff' },
        partColors: {},
        gradientColors: {},
        parts: [],
        newKey: null,
        isActive: true
      };
    }
  },

  switchProduct: function(productId) {
    if (this.products[productId]) {
      this.currentProductId = productId;
      // Update all products' active status
      Object.keys(this.products).forEach(id => {
        this.products[id].isActive = (id === productId);
      });
      this.updateTrigger++;
      
      // Force material reload for the switched product
      if (this.products[productId].materialState) {
        this.products[productId].materialState.texturesLoaded = false;
        this.products[productId].materialState.materialsApplied = false;
      }
    }
  },
  
  // Update specific product property
  updateProductProperty: function(productId, key, value) {
    if (this.products[productId]) {
      this.products[productId][key] = value;
      
      // If updating modelName, reset material state
      if (key === 'modelName') {
        this.products[productId].materialState = {
          texturesLoaded: false,
          materialsApplied: false,
          lastModelUrl: value
        };
      }
      
      this.updateTrigger++;
    }
  },

  // Update current product property
  updateCurrentProduct: function(key, value) {
    this.updateProductProperty(this.currentProductId, key, value);
  },

  setViewSide: function(side) {
    if (this.products[this.currentProductId]) {
      this.products[this.currentProductId].viewSide = side;
      this.updateTrigger++;
    }
  },

  // Mark textures as loaded for a product
  markTexturesLoaded: function(productId) {
    if (this.products[productId]?.materialState) {
      this.products[productId].materialState.texturesLoaded = true;
      this.updateTrigger++;
    }
  },

  // Mark materials as applied for a product
  markMaterialsApplied: function(productId) {
    if (this.products[productId]?.materialState) {
      this.products[productId].materialState.materialsApplied = true;
      this.updateTrigger++;
    }
  },

  forceRefresh: function() {
    this.updateTrigger = (this.updateTrigger || 0) + 1;
    
    // Also trigger updates on all products
    Object.keys(this.products).forEach(productId => {
      const product = this.products[productId];
      // Touch properties to trigger reactivity
      if (product) {
        product.id = product.id;
        if (product.materialState) {
          product.materialState = { ...product.materialState };
        }
      }
    });
  },
});

export default state;